/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

export class CreateAccountInput {
  'cloudProvider': Provider;
  /**
  * The role to access the account
  */
  'role': string;
  /**
  * The relevant regions for the account. For restore account
  */
  'regions'?: Array<string>;
  /**
  * The tags for the account
  */
  'tags'?: { [key: string]: string; };
  /**
  * Friendly name for the account
  */
  'name'?: string;
  /**
  * The tenant ID
  */
  'tenantId'?: string;
  /**
  * The application ID
  */
  'applicationId'?: string;
  /**
  * Whether this account overrides the default network configuration
  */
  'overrideDefaultNetworkConfig'?: boolean;
  /**
  * Whether this account is used for eon internal diagnostics
  */
  'isInternal'?: boolean;
  /**
  * Whether this account is owned by the customer
  */
  'isCustomerOwned'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "role",
      "baseName": "role",
      "type": "string",
      "format": ""
    },
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "overrideDefaultNetworkConfig",
      "baseName": "overrideDefaultNetworkConfig",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isInternal",
      "baseName": "isInternal",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isCustomerOwned",
      "baseName": "isCustomerOwned",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateAccountInput.attributeTypeMap;
  }

  public constructor() {
  }
}



